import PropTypes from 'prop-types';
import React from 'react';
import {connect} from "react-redux";

import "./ToolTip.css";

const EMPTY_TEXT = "(none)";

export class ToolTip extends React.Component {
    static propTypes = {
        x: PropTypes.number,
        y: PropTypes.number,
        contents: PropTypes.any
    };

    static displayName = 'ToolTip';

    updateTimer = null;

    constructor(...args) {
        super(...args);
        this.state = {width: 0, height: 0};
    }

    updateSize() {
        if (this.element) {
            let {height, width} = this.element.getBoundingClientRect();
            if (height != this.state.height || width !== this.state.width) {
                this.setState({height, width});
            }
        }
        
    }

    componentDidUpdate(prevProps) {
        let {contents} = this.props;
        if (contents && prevProps.contents !== contents) {
            if (!this.updateTimer) {
                this.updateTimer = requestAnimationFrame(() => {
                    this.updateSize();
                    this.updateTimer = null;
                });
            }
        }
    }


    render() {
        let {contents, x, y} = this.props;

        if (!contents) {
            return null;
        }

        let size = this.state;

        if (y + 20 + size.height > window.innerHeight) {
            y -= size.height + 5;
        } else {
            y += 15;
        }

        if (x + 20 + size.width > window.innerWidth) {
            x -= size.width + 5;
        } else {
            x += 15;
        }

        if (typeof contents == "object") {
            contents = Object.keys(contents)
                .map(name => name + ": " + (contents[name] != "" ? contents[name] : EMPTY_TEXT))
                .join("\n");
        }

        let styles = {
            position: "fixed",
            top: y,
            left: x
        };

        return (
            <div ref={ref => this.element = ref} className="abusesa-tooltip" style={styles}>
                <div className="abusesa-tooltip-content">{contents}</div>
            </div>
        );
    }
}

export default connect(
    ({tooltip}) => ({
        contents: tooltip.contents,
        x: tooltip.x,
        y: tooltip.y
    })
)(ToolTip);


// WEBPACK FOOTER //
// ./src/components/ToolTip.jsx